// test1249
(1249 && 0);
